import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/discover.svg";
var DiscoverSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  DiscoverSolid_default as default
};
